export default __webpack_public_path__ + "static/media/me3_ECAP_University_Icon.f38e47f5.svg";